import {
    ErrorBoundary,
    LogLevel,
    useLogger,
} from '@amzn/event-engine-js-utils';
import ErrorPageController from 'components/ErrorPageController';
import React, { FC, PropsWithChildren, ReactNode } from 'react';

interface ErrorBoundaryWithLoggerProps {
    children: PropsWithChildren<ReactNode>;
    loggerName: string;
    logLevel?: LogLevel;
}

export const ErrorBoundaryWithLogger: FC<ErrorBoundaryWithLoggerProps> = ({
    children,
    loggerName,
    logLevel = LogLevel.CRITICAL,
}) => {
    const [errorBoundaryLogger] = useLogger(loggerName, logLevel);

    return (
        <ErrorBoundary
            logger={errorBoundaryLogger}
            fallback={
                <ErrorPageController type="embedded-build-catastrophic-error" />
            }>
            {children}
        </ErrorBoundary>
    );
};

export default ErrorBoundaryWithLogger;
